import React from 'react';
import { getDomainCfg } from '../core/state';
import { translate } from '../core/i18n';
import { QuestsContainer } from '../components/quest/QuestContainer';
import { RoundButton } from '../components/buttons/base/RoundButton';
import { getRedirectUrl, redirectTo } from '../features/redirect';

export const QuestView = () => {

  const exitRequested = () => {
    redirectTo(getRedirectUrl(getDomainCfg().viewSettings.projectsView));
  }

  const menu = <div>
    <RoundButton className="home-btn btn-margins" title={translate('exit-btn-title')} onClick={exitRequested} icon="right-to-bracket" iconColor="#ffffff" borderColor='#2243ba' backgroundColor='#305eff' />
  </div>
  const container = (
    <div className="row" id="achievementcontainer">
      <div className="col-12">
        <div className="rounded-lg shadow mb-5 bg-white border bordersize-15 scrollable-map">
          <QuestsContainer />
        </div>
      </div>
    </div>
  );

  return (
    <>      
      <div className="container text-center">
        <div className="row">
          <div className="col">
            <p className="h3"><img src={ getDomainCfg().product.logoUrl } className="imgcenter productLogo" width="281" max-height="57" alt={ getDomainCfg().product.name } /></p>
            <p className="text-center">{ translate("view-quest-header", getDomainCfg().product.name)}</p>
          </div>
        </div>
        {/* Hier können Sie zusätzliche Menüs oder Buttons hinzufügen, wenn Sie welche haben */}
        <div className="row row-cols-1 text-end mb-10">
          { menu }
        </div>
          {  container }
      </div>
    </>
  );
};

export default QuestView;
